module.exports = __webpack_public_path__ + "img/clientes.fcd49828.svg";